import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { markAbsentAttendance } from "@/config/mutation/employee";
import { Button } from "@/components/ui/button/button";
import { toast } from "sonner";
import { AxiosError } from "axios";

export const MarkYourselfAbsent = ({
  attId,
  handleClose,
}: {
  attId: string;
  handleClose: () => void;
}) => {
  const empKey = Cookies.get("key") as string;
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: markAbsentAttendance(empKey),
  });

  const onSubmit = () => {
    // console.log(values);
    mutate(attId, {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ["emp-attendance-with-monthyear"],
        });
        toast.success("Attendance Absent marked!");
        handleClose();
      },
      onError: (error) => {
        console.log("ERROR WHILE MARKING EMPLOYEE ABSENT", error);
        const isAxiosError = error instanceof AxiosError;
        if (isAxiosError) {
          const errorReason = error?.response?.data?.error as string;
          toast.error(errorReason);
        } else {
          toast.error(error?.message);
        }
      },
    });
  };

  return (
    <div>
      <div className="flex items-center">
        <Button type="button" disabled={isPending} onClick={onSubmit}>
          Mark absent
        </Button>
      </div>
    </div>
  );
};
